import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";

export default function TermsAndConditionsPlainContentBE() {
    const initStrings =
        {
            header: stringsTranslate(appWords.general_conditions_knaek),
            "termsdata": [

                {
                    "id": 1,
                    "title": stringsTranslate(appWords.terms_and_conditions),
                    "terms_content": [
                        {

                            "section": stringsTranslate(appWords.in_these_terms_and_conditions_we_have_described_the_rules_that_apply_to_each_other)

                        },
                        {

                            "section": stringsTranslate(appWords.alert_privacy_policy)

                        },
                        {
                            "section": stringsTranslate(appWords.we_have_done_our_best_to_describe_the_terms_and_conditions_as_clearly_as_possible)
                        },
                        {
                            "section": stringsTranslate(appWords.do_you_have_a_tip__question_or_comment__please_fee)
                        },
                        {
                            "section": "<a href='mailto:info@knaek.be'>info@knaek.be </a>"
                        },
                        {
                            "section": stringsTranslate(appWords.when_you_take_out_a_membership_with_knaek_go_)
                        },

                        {
                            "section": stringsTranslate(appWords.these_general_terms_and_conditions_are_effective_a),
                        }
                    ],

                },
                {
                    "id": 2,
                    "title": stringsTranslate(appWords.article_1_definitions),
                    "terms_content": [
                        {


                            "section": stringsTranslate(appWords.in_these_general_terms_and_conditions_we_mean_by),

                        },
                        {
                            "header": stringsTranslate(appWords.knaek_we),
                            "section": stringsTranslate(appWords.the_private_company_knaek_b_v_located_at_admirale)
                        },
                        {
                            "header": stringsTranslate(appWords.member),
                            "section":
                                stringsTranslate(appWords.any_natural_person_who_represents_a)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.user),
                            "section":
                                stringsTranslate(appWords.someone_who_uses_the_knaekapp_via_a_one_time_activ)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.you),
                            "section":
                                stringsTranslate(appWords.the_member__user_or_visitor_of_our)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.knaekapp)
                            ,
                            "section":
                                stringsTranslate(appWords.knaek_s_digital_discount_pass)
                        },
                        {
                            "header":
                                stringsTranslate(appWords.knaek_id)
                            ,
                            "section":
                                stringsTranslate(appWords.the_activation_code_issued_by_knaek_that_gives_acc)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.acceptable)
                            ,
                            "section":
                                stringsTranslate(appWords.the_company_or_institution_that_accepts_the_knaeka)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.membership_fee)
                            ,
                            "section":
                                stringsTranslate(appWords.the_annual_fee_you_pay)
                        },
                        {
                            "header":
                                stringsTranslate(appWords.agreement)
                            ,
                            "section":
                                stringsTranslate(appWords.the_agreement_between_the_member)
                        },
                        {
                            "header":
                                stringsTranslate(appWords.college_year)
                            ,
                            "section":
                                stringsTranslate(appWords.the_academic_year_starts_on_august_1_of_the_relev)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.knaek_cashback)
                            ,
                            "section":
                                stringsTranslate(appWords.the_service_provided_by_our_partner_the_affiliate_)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.knaek_platform)
                            ,
                            "section":
                                stringsTranslate(appWords.the_service_platform)

                        },
                    ],


                },
                {
                    "id": 3,
                    "title":
                        stringsTranslate(appWords.article_2_applicability)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.these_general_terms_and_conditions_apply__unless_o)

                        },
                    ],
                },
                {
                    "id": 4,
                    "title":
                        stringsTranslate(appWords.article_3_membership)
                    ,
                    "terms_content": [
                        {
                            "section":
                                stringsTranslate(appWords.as_a_valued_member_of_knaek__you_will_receive_acce)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.by_selling_membership__we_are_able_to_offer_the_ve)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.you_can_become_a_member_of_knaek_in_the_following_)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.you_can_only_become_a_member_if_you_are_a_student)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.membership_starts_immediately_after_registration)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.when_you_take_out_a_membership_at_knaek)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.we_charge_a_membership_fee_for_membership)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.you_pay_your_membership_fee_by_direct_debit_or_cre)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.you_can_cancel_your_subscription_with_knaek_subjec)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.membership_can_be_canceled_at_any_time9)

                        },
                        {
                            "section":

                                stringsTranslate(appWords.membership_can_be_canceled_at_any_time)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.you_will_always_have_to_cancel_the_membership_your)

                        },

                    ],


                },
                {
                    "id": 5,
                    "title":
                        stringsTranslate(appWords.article_4_payment_of_the)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.the_payment_of_your_membership_fee_contributes_to)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.as_a_member_of_knaek_you_are_a_financial_contribut)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_membership_fee_is_debited_at_the_end_of_each)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.if_you_cancel_prematurely__you_will_receive_an_ema)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.if_we_are_unable_to_debit_the_membership_fee_from_)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.if_you_do_not_pay_a_payment_request_on_time__we_wi)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.in_the_exceptional_case_that_your_account_number_i)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_reversal_or_blocking_of_a_direct_debit_by)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.although_we_rarely_increase_the_membership_fee)

                        },
                    ],

                },
                {
                    "id": 6,
                    "title":
                        stringsTranslate(appWords.article_5_right_of_withdrawal)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.if_you_take_out_a_membership_with_knaek_via_our_di)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_cooling_off_period_starts_on_the_day_after_you)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.if_you_use_the_right_of_withdrawal)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_right_of_withdrawal_is_not_valid_if_you_have_b)

                        },
                    ],

                },
                {
                    "id": 7,
                    "title":
                        stringsTranslate(appWords.article_6_the_knaek_id)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.the_knaek_id_is_an_activation_code_that_can_be_act)

                        },
                        {
                            "header":

                                stringsTranslate(appWords.one_time_activation_code)
                            ,
                            "section":
                                stringsTranslate(appWords.these_are_the_knaek_ids_that_we_hand_out_to_partne)

                        },
                        {
                            "header":
                                stringsTranslate(appWords.membership_with_continuous_activation_code)
                            ,
                            "section":
                                stringsTranslate(appWords.this_is_a_personal_knaek_id_that_you_receive_as_a_)


                        },

                    ],


                },
                {
                    "id": 8,
                    "title":
                        stringsTranslate(appWords.article_7_cancellation)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.have_you_graduated_or_do_you_no_longer_want_to_be_)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.are_you_canceling_for_another_reason_we_are_always)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.membership_can_be_canceled_at_any_time_1)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.please_note_that_you_will_always_receive_a_cancell)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.if_you_have_cancelled__your_knaek_id_will_expire_a)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.as_a_member_you_retain_the_obligation_to_terminate)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.in_case_you_still_have_a_membership_fee_open)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.knaek_is_free_to_do_so_without_stating_reasons)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.knaek_is_free_to_do_so_without_stating_reasons7)

                        },
                    ],

                },
                {
                    "id": 9,
                    "title":
                        stringsTranslate(appWords.article_8_obligations_and_indemnifications)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.we_inform_our_members__among_other_things__through)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.we_make_every_effort_to_update_this_information_re)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_user_of_the_knaekapp_must_ask_for_a_knaek_disc)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.despite_the_fact_that_we_make_every_effort_to_comm)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.despite_the_fact_that_we_make_every_effort_to_comm4)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.despite_the_fact_that_we_make_every_effort_to_comm5)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.despite_the_fact_that_we_make_every_effort_to_comm6)

                        },
                        // {
                        //     "section":
                        //         stringsTranslate(appWords.despite_the_fact_that_we_make_every_effort_to_comm7)
                        //
                        // },

                    ],

                },
                {
                    "id": 10,
                    "title":
                        stringsTranslate(appWords.article_9_obligations_of_members_or_users)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.as_a_member_user__you_submit_your_knaek_id_yoursel)

                        },
                    ],

                },
                {
                    "id": 11,
                    "title":
                        stringsTranslate(appWords.article_10_annual_contribution)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_2)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_3)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_4)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_5)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_6)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_7)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_8)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_9)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.the_annual_contribution_for_membership_is_25_inclu_10)

                        },
                    ],

                },
                {
                    "id": 12,
                    "title":
                        stringsTranslate(appWords.article_11_personal_data)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.we_process_your_contact_details)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.as_a_member_or_user_you_have_the_right_to_inspect_)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.bank_details_of_members_are_shared_with_our_admini)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.the_knaekapp_is_intended_to_benefit_the_member_or_)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.phone_calls_with_the_member_or_user_can_be)

                        },
                    ],

                },
                {
                    "id": 13,
                    "title":
                        stringsTranslate(appWords.article_12_liability)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na_2)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na_3)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na_4)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na_5)

                        },
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_liable_for_any_damage__by_whatever_na_6)

                        },
                    ],

                },
                {
                    "id": 14,
                    "title":
                        stringsTranslate(appWords.article_13_force_majeure)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.knaek_is_not_obliged_to_fulfill_any_obligation)

                        },
                    ],

                },
                {
                    "id": 15,
                    "title":
                        stringsTranslate(appWords.articles_14)
                    ,
                    "terms_content": [
                        {

                            "section":
                                stringsTranslate(appWords.article_14_correspondence_and_changes_of_address)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.correspondence_related_to_knaek_such_as_correspon)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.in_case_of_a_change_of_address__the_member_or_user)

                        },
                    ],
                },
                {
                    "id": 16,
                    "title":
                        stringsTranslate(appWords.articles_15)
                    ,
                    "terms_content": [

                        {

                            "section":
                                stringsTranslate(appWords.despite_all_the_care_we_devote_to_our_services__it)

                        },
                        {
                            "section":
                                stringsTranslate(appWords.despite_all_the_care_we_devote_to_our_services_2_it)

                        },
                    ],
                },
                {
                    "id": 17,
                    "title":
                        stringsTranslate(appWords.articles_16)
                    ,
                    "terms_content": [

                        {

                            "section":
                                stringsTranslate(appWords.article_16_amendment_of_the_general_terms_and_con)

                        },
                    ],
                },
                {
                    "id": 18,
                    "title":
                        stringsTranslate(appWords.articles_17)
                    ,
                    "terms_content": [
                        {
                            "section":
                                stringsTranslate(appWords.we_are_at_all_times_entitled_to_these_terms_and_co)

                        },
                    ],
                },


            ],
            "cashback_content": [
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.why_cashback_never_guaranteed_title),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.why_cashback_never_guaranteed_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.how_do_i_get_my_discount),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.log_in_with_your_knaek_id),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.how_do_you_know_what_i_have_bought),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.if_you_are_logged_in_and_want_to_make_a_purchase_f),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.will_i_see_my_discount_immediately_when_i_check_ou),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.because_we_only_receive_money_from_the_webshop_aft),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.what_if_still_dont_see_discount_in_app_title),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.what_if_still_dont_see_discount_in_app_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.why_does_the_approval_of_my_order_take_longer_than),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords._remains_until_the_webshop_has),
                        },

                    ],
                }, {
                    "id": 1,
                    "title": stringsTranslate(appWords.when_will_i_receive_my_cashback),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.most_webshops_apply_the_statutory_return_period_of),
                        },

                    ],
                }, {
                    "id": 1,
                    "title": stringsTranslate(appWords.how_do_i_get_the_money_from_my_account_to_my_bank_),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.if_your_rebate_is_approved_by_the_webshop__you_can),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.how_long_does_the_payment_take),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.once_your_cashback_has_been_approved_by_the_websho),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.can_pay_out_less_than_saved_title),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.can_pay_out_less_than_saved_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.where_is_my_transaction),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.if_your_cashback_is_not_visible__then_the_shop_has),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.my_cashback_is_too_low__what_now),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.your_cashback_is_calculated_on_the_purchase_amount),
                        },

                    ],
                },

                {
                    "id": 1,
                    "title": stringsTranslate(appWords.is_the_discount_also_valid_with_special_offers_and),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.yes__all_cashback_discounts_are_valid_in_combinati),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.does_cashback_also_apply_on_purchases_in_shop),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords._you_cannot_receive_cashback_on_in_store_purcha),
                        },

                    ],
                },
                {
                    "id": 1,
                    "title": stringsTranslate(appWords.i_forgot_to_use_cashback__can_i_still_get_it),
                    "cashback_content": [
                        {
                            "section": stringsTranslate(appWords.unfortunately__this_is_not_possible),
                        },

                    ],
                }
            ],
            "how_cashback_works": stringsTranslate(appWords.how_cashback_works),
            "faqData": [
                {
                    "id": 1,
                    "link": 'order-knaek',
                    "title": stringsTranslate(appWords.how_can_i_order_my_knaek_id),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.you_can_order_your_knaek_id_via_the_website_or_app),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'knaek-pricing',
                    "title": stringsTranslate(appWords.what_does_knaek_cost),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.knaek_costs_25_per_college_year_which_is_about),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'collect-payments',
                    "title": stringsTranslate(appWords.collect_payments_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.collect_payments_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'find-knaek-id',
                    "title": stringsTranslate(appWords.where_can_i_find_my_knaek),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.if_your_membership_has_been_renewed),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'knaek-id-used',
                    "title": stringsTranslate(appWords.my_knaek_id_has_already_been_used),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.if_your_knaek_id_has_already_been_used__you_have_p),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'pas-vs-app',
                    "title": stringsTranslate(appWords.not_receiving_emails_from_Knaek_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.not_receiving_emails_from_Knaek_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'cancel-membership',
                    "title": stringsTranslate(appWords.how_can_i_cancel_my_membership),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.enter_your_e_mail_address_and_you_will_receive_an_),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'when-cancel',
                    "title": stringsTranslate(appWords.what_if_i_don),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.if_we_fail_to_debit_the_membership_fee_from_your_a),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'membership-linked-student',
                    "title": stringsTranslate(appWords.membership_linked_student_email_no_longer_access_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.membership_linked_student_email_no_longer_access_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'canceled-by-phone',
                    "title": stringsTranslate(appWords.already_canceled_by_phone_what_should_do_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.already_canceled_by_phone_what_should_do_content),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'not-paying',
                    "title": stringsTranslate(appWords.what_if_I_do_not_pay_for_my_membership),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.if_we_do_not_succeed_in_debiting_membership_fee_from_your),
                        },

                    ],
                },
                {
                    "id": 1,
                    "link": 'remaining-fee',
                    "title": stringsTranslate(appWords.how_is_my_remaining_membership_fee_calculated),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.you_have_just_canceled_your_membership_at_knaek_and_an_outstanding_amount_appears_on),
                        },

                    ],
                },
                {
                    "id": 2,
                    "link": 'yearly-fee',
                    "title": stringsTranslate(appWords.how_will_i_be_charged_for_my_annual_membership_fee),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.how_will_i_be_charged_for_my_annual_membership_fee_answer),
                        },

                    ],
                },
                {
                    "id": 2,
                    "link": 'trust-pilot-reviews',
                    "title": stringsTranslate(appWords.trust_pilot_reviews_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.trust_pilot_reviews_content),
                        },

                    ],
                },
                {
                    "id": 2,
                    "link": 'long-respond',
                    "title": stringsTranslate(appWords.long_respond_to_email_title),
                    "vacancy_content": [
                        {
                            "section": stringsTranslate(appWords.long_respond_to_email_content),
                        },

                    ],
                },
            ],
            faq: stringsTranslate(appWords.faq),
            faq_heading: stringsTranslate(appWords.contact_heading_text_two),
            feq_subheading: stringsTranslate(appWords.contact_subheading_text_two),
        }

    function stripHtml(htmlString) {
        return htmlString.replace(/<[^>]*>?/gm, '');
    }
    return (
        <section className="section terms-area py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <div className="mb-5 text-center">
                            <h1>{initStrings.header}</h1>
                        </div>

                        {initStrings.termsdata.map((item) => (
                            <div key={item.id} className="mb-5">
                                <h3 className="mb-3">{item.title}</h3>
                                {item.terms_content.map((content, idx) => (
                                    <div key={idx} className="mb-3">
                                        {content.header && <h5 className="mb-1">{content.header}</h5>}
                                        <p>{stripHtml(content.section)}</p>
                                    </div>
                                ))}
                            </div>
                        ))}

                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                    <div className="mb-5 text-center">
                        <h1>{initStrings.faq_heading}</h1>
                    </div>

                    <div className="row col-12 mt-3">
                        <p>{initStrings.feq_subheading}</p>
                    </div>

                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                    <div className="mb-5 text-center">
                        <h1>{initStrings.how_cashback_works}</h1>
                    </div>

                    {initStrings.cashback_content.map((item) => (
                        <div key={item.id} className="mb-5">
                            <h3 className="mb-3">{item.title}</h3>
                            {item.cashback_content.map((content, idx) => (
                                <div key={idx} className="mb-3">
                                    {content.header && <h5 className="mb-1">{content.header}</h5>}
                                    <p>{stripHtml(content.section)}</p>
                                </div>
                            ))}
                        </div>
                    ))}

                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                    <div className="mb-5 text-center">
                        <h1>{initStrings.faq}</h1>
                    </div>

                    {initStrings.faqData.map((item) => (
                        <div key={item.id} className="mb-5">
                            <h3 className="mb-3">{item.title}</h3>
                            {item.vacancy_content.map((content, idx) => (
                                <div key={idx} className="mb-3">
                                    {content.title && <h5 className="mb-1">{content.title}</h5>}
                                    <p>{stripHtml(content.section)}</p>
                                </div>
                            ))}
                        </div>
                    ))}

                </div>
            </div>
        </section>
    );

}


